import layout from "~/layout/App/Index.vue";
import auth from "../middleware/auth";

const mcpAccessRoutes = {
  path: "/mcp-access",
  component: layout,
  name: "mcp",
  meta: {
    middleware: auth
  },
  children: [
    {
      path: "",
      component: () => import("~/views/McpAccess/Index.vue"),
      name: "mcp.access.index",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: "mcp_access.title", route: "mcp.access.index" }
        ]
      }
    }
  ]
};

export default mcpAccessRoutes;
